<template>
	<div class="tool-bar" @click="preventBubbling"><tool-segment v-for="segment of toolbar.segments" :key="segment.id" :segment="segment" @action="replayAction"></tool-segment></div>
</template>

<script setup lang="ts">
import type {Toolbar} from "@t/ui/Toolbar.ts";
import ToolSegment from "@/ui/toolbar/ToolSegment.vue";

defineProps<{
	toolbar: Toolbar
}>();
const emit = defineEmits(["action"]);

function replayAction(id: string, arg?: any) {
	emit("action", id, arg);
}

function preventBubbling(e: MouseEvent) {
	e.preventDefault();
	e.stopPropagation();
}
</script>

<style>
.tool-bar {
	display: inline-flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: baseline;
	column-gap: 12px;
	border-radius: var(--input-radius);
	font-size: 14px;
	line-height: var(--input-height);
	padding: 0;
	cursor: default;
	user-select: none;
	-webkit-user-select: none;

	background-color: var(--toolbar-bg);
	color: var(--toolbar-fg);
	outline: 1px solid var(--menu-border-color);
	box-shadow: var(--panel-shadow);
	z-index: var(--drop-z-index);
}
</style>